import { Text } from "@chakra-ui/react";

const PageDashboard = function(){
    return <Text></Text>
};

export default PageDashboard;